import chroma from 'chroma-js'
import styled from 'styled-components'

export const GridContainer = styled.div`
  display: flex;
  column-gap: 8px;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 8px;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) =>
    chroma(theme.color.base.c9).alpha(0.9).css()};
`

export const GridText = styled.div`
  padding: 8px 16px 0px 16px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: ${({ theme }) => theme.color.base.c0};
`
